import { type RTEFormatOpts } from "../RichTextEditorProps";

export interface RTEInlineFormatProps {
  readonly format: RTEFormatOpts;
  readonly lexicalTag: string;
  readonly tag: string;
  readonly className: string;
}

export const INLINE_FORMATS: ReadonlyArray<RTEInlineFormatProps> = [
  { format: "strikethrough", lexicalTag: "s", tag: "s", className: "strikethrough" },
  { format: "underline", lexicalTag: "u", tag: "u", className: "underlined" },
  { format: "italic", lexicalTag: "i", tag: "em", className: "italic" },
  { format: "bold", lexicalTag: "b", tag: "strong", className: "semibold" },
];

export const INLINE_FORMAT_NAMES: ReadonlyArray<RTEFormatOpts> = INLINE_FORMATS.map((entry) => entry.format);
